import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

axios.defaults.withCredentials = true;

export const AuthService = {
  login: (username: string, password: string) => {
    return axios.post(`${API_BASE_URL}/auth/login`, { username, password });
  },

  logout: () => {
    return axios.post(`${API_BASE_URL}/auth/logout`);
  },

  getStatus: () => {
    return axios.get(`${API_BASE_URL}/auth/status`);
  }
};